import { render, staticRenderFns } from "./MoneyBack.vue?vue&type=template&id=6055f046&scoped=true&"
import script from "./MoneyBack.vue?vue&type=script&lang=js&"
export * from "./MoneyBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055f046",
  null
  
)

export default component.exports